"use strict";
var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  var defaultSettings = { pagination: ".AjaxinatePagination", method: "scroll", container: ".AjaxinateLoop", offset: 0, loadingText: "Loading...", callback: null };
  this.settings = Object.assign(defaultSettings, settings);
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = { click: this.addClickListener, scroll: this.addScrollListeners };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener("scroll", this.checkIfPaginationInView);
    window.addEventListener("resize", this.checkIfPaginationInView);
    window.addEventListener("orientationchange", this.checkIfPaginationInView);
  }
};
Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  console.log('Huratips');
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
    }
  }
};
Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};
Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;

      this.loadMore();
    }
  }
};


// Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
//   this.request = new XMLHttpRequest();
//   this.request.onreadystatechange = function success() {
//     if (this.request.readyState === 4 && this.request.status === 200) {
//       var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
//       var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
//       this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);
//       this.paginationElement.innerHTML = newPagination.innerHTML;
//       if (this.settings.callback && typeof this.settings.callback === "function") {
//         this.settings.callback(this.request.responseXML);
//       }
//       this.initialize();
//       var loadresult = $("#Huratips-Pagination a").hasClass("load-more-btn");
//       if(loadresult == false){
//         var unavailabledata =''; 
//         $(".produts-unavailable").each(function(){
//           var current = $(this).html();
//           unavailabledata +=current;
//           console.log('unavailabledata');
//         });
//         $("#Huratips-Loop").append(unavailabledata);
//         $(".produts-unavailable").remove();
//         //                 resize the window
//         window.dispatchEvent(new Event('resize'));

//       }
//                 console.log('load images');
//       var GetCurrenyCurrency= $.trim($('.Currency-converter-app .current.notranslate').text());
//       $('li.option.notranslate[data-value="'+GetCurrenyCurrency+'"]').trigger('click');
//       $('li.option.notranslate[data-value="'+GetCurrenyCurrency+'"]').trigger('click');


//     }
//   }.bind(this);
//   this.request.open("GET", this.nextPageUrl);
//   this.request.responseType = "document";
//   this.request.send();
// };
// Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
//   var _this = this;
//   this.request = new XMLHttpRequest();

//   this.request.onreadystatechange = function () {
//     if (this.readyState === 4 && this.status === 200) {
//       var responseDoc = this.responseXML;
//       var newContainer = responseDoc.querySelector(_this.settings.container);
//       var newPagination = responseDoc.querySelector(_this.settings.pagination);

//       if (!newContainer) return;

//       console.log("here")
//       console.log(newContainer, newPagination);
//       // Append new products
//       _this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);

//       // Update pagination only if it exists in next page
//       if (newPagination) {
//         _this.paginationElement.innerHTML = newPagination.innerHTML;
//       } else {
//         // No more pages — remove pagination completely
//         _this.paginationElement.remove();
//       }

//       // Run callback if defined
//       if (_this.settings.callback && typeof _this.settings.callback === "function") {
//         _this.settings.callback(responseDoc);
//       }

//       // Only reinitialize if pagination still exists (avoid double load)
//       if (document.querySelector(_this.settings.pagination)) {
//         _this.initialize();
//       }

//       // ===== Custom post-load logic =====
//       var loadresult = $("#Huratips-Pagination a").hasClass("load-more-btn");
//       if (!loadresult) {
//         var unavailabledata = "";
//         $(".produts-unavailable").each(function () {
//           unavailabledata += $(this).html();
//         });
//         $("#Huratips-Loop").append(unavailabledata);
//         $(".produts-unavailable").remove();
//         window.dispatchEvent(new Event("resize"));
//       }

//       // Currency trigger re-run
//       var GetCurrenyCurrency = $.trim($('.Currency-converter-app .current.notranslate').text());
//       $('li.option.notranslate[data-value="' + GetCurrenyCurrency + '"]').trigger("click");
//     }
//   };

//   this.request.open("GET", this.nextPageUrl, true);
//   this.request.responseType = "document";
//   this.request.send();
// };


// Saahil changes
Ajaxinate.prototype.loadMore = function() {
  var _this = this;
  if (this.loading) return; 
  this.loading = true;

  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function() {
   if (this.readyState === 4 && this.status === 200) {
      var responseDoc = this.responseXML;
      var newContainer = responseDoc.querySelector(_this.settings.container);
      var newPagination = responseDoc.querySelector(_this.settings.pagination);

      if (!newContainer) return;

      _this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);

      if (newPagination) {
        _this.paginationElement.innerHTML = newPagination.innerHTML;
      } else {
        _this.paginationElement.remove();
      }

      // ===== Custom post-load logic =====
      var loadresult = $("#Huratips-Pagination a").hasClass("load-more-btn");
      // if (!loadresult) {
      //   var unavailabledata = "";
      //   $(".produts-unavailable").each(function () {
      //     unavailabledata += $(this).html();
      //   });
      //   $("#Huratips-Loop").append(unavailabledata);
      //   $(".produts-unavailable").remove();
      //   window.dispatchEvent(new Event("resize"));
      // }

      if (loadresult == false) {
        $(".produts-unavailable").each(function () {
          const $inner = $(this).children(); 
          $("#Huratips-Loop").append($inner);
          $(this).remove();
        });

        window.dispatchEvent(new Event('resize'));
      }

      // Currency trigger re-run
      var GetCurrenyCurrency = $.trim($('.Currency-converter-app .current.notranslate').text());
      $('li.option.notranslate[data-value="' + GetCurrenyCurrency + '"]').trigger("click");

      // Reinitialize pagination if still exists
      if (document.querySelector(_this.settings.pagination)) {
        _this.initialize();
      }

      _this.loading = false;
    }

  };

  this.request.open("GET", this.nextPageUrl, true);
  this.request.responseType = "document";
  this.request.send();
};





Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
};
Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener("scroll", this.checkIfPaginationInView);
  window.removeEventListener("resize", this.checkIfPaginationInView);
  window.removeEventListener("orientationchange", this.checkIfPaginationInView);
};
Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
  var destroyers = { click: this.removeClickListener, scroll: this.removeScrollListener };
  destroyers[this.settings.method]();
  return this;
};


// Ajaxinate.prototype.loadMore = function () {
//   this.request = new XMLHttpRequest();

//   this.request.onreadystatechange = function () {
//     if (this.request.readyState === 4 && this.request.status === 200) {
//       var newDoc = this.request.responseXML;
//       var newContainer = newDoc.querySelector(this.settings.container);
//       var newPagination = newDoc.querySelector(this.settings.pagination);

//       if (newContainer) {
//         // 🔹 Get all new product cards
//         var newProducts = newContainer.querySelectorAll('[data-product-card]');

//         // 🔹 Append only products not already in DOM
//         newProducts.forEach((product) => {
//           var pid = product.getAttribute('data-product-id');
//           // skip if same product already rendered
//           if (!document.querySelector('[data-product-id="' + pid + '"]')) {
//             this.containerElement.appendChild(product);
//           }
//         });
//       }

//       // 🔹 Update pagination
//       if (newPagination && this.paginationElement) {
//         this.paginationElement.innerHTML = newPagination.innerHTML;
//       }

//       // 🔹 Trigger callback
//       if (this.settings.callback && typeof this.settings.callback === "function") {
//         this.settings.callback(this.request.responseXML);
//       }

//       this.initialize();

//       console.log('✅ New products appended, no duplicates');

//       // 🔹 Currency update (if required)
//       var currentCurrency = $.trim($('.Currency-converter-app .current.notranslate').text());
//       $('li.option.notranslate[data-value="' + currentCurrency + '"]').trigger('click');
//       $('li.option.notranslate[data-value="' + currentCurrency + '"]').trigger('click');
//     }
//   }.bind(this);

//   this.request.open("GET", this.nextPageUrl);
//   this.request.responseType = "document";
//   this.request.send();
// };